import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { clientPortalApi } from '../../services/api';
import { useClientPortalAuth } from '../../context/ClientPortalAuthContext';
import './ClientPortal.css';

const ClientPortalLogin: React.FC = () => {
  const navigate = useNavigate();
  const { isAuthenticated, login } = useClientPortalAuth();

  const [identifier, setIdentifier] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (isAuthenticated) {
      navigate('/client/profile');
    }
  }, [isAuthenticated, navigate]);

  const handleSubmit = async (event: React.FormEvent) => {
    event.preventDefault();

    if (!identifier.trim() || !password.trim()) {
      setError('Veuillez saisir votre email ou telephone, puis votre mot de passe.');
      return;
    }

    setLoading(true);
    setError('');

    try {
      const response = await clientPortalApi.login(identifier.trim(), password);
      const data = response.data;

      if (!data?.success || !data?.token || !data?.client) {
        setError(data?.error || 'Connexion client impossible.');
        return;
      }

      login(data.token, data.client);
      navigate('/client/profile');
    } catch (err: any) {
      setError(err.response?.data?.error || 'Connexion client impossible.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="client-portal-shell client-portal-login">
      <div className="client-portal-login-card">
        <span className="client-portal-kicker">Support Client</span>
        <h1>Connexion client</h1>
        <p className="client-portal-subtitle">
          Connectez-vous avec votre email ou votre telephone si vous avez au moins un
          contrat actif non expire.
        </p>

        {error && <div className="error-message">{error}</div>}

        <form className="client-portal-form" onSubmit={handleSubmit}>
          <div className="form-group">
            <label>Email ou telephone</label>
            <input
              type="text"
              value={identifier}
              onChange={(e) => setIdentifier(e.target.value)}
              placeholder="Ex: info@client.dz ou 0550123456"
              autoComplete="username"
            />
          </div>

          <div className="form-group">
            <label>Mot de passe</label>
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              autoComplete="current-password"
            />
          </div>

          <button type="submit" className="btn btn-primary" disabled={loading}>
            {loading ? 'Connexion...' : 'Entrer dans le portail'}
          </button>
        </form>

        <p className="client-portal-hint">
          Premiere connexion: le mot de passe par defaut est <strong>1</strong>. Il sera
          possible de le changer dans votre profil juste apres connexion.
        </p>
      </div>
    </div>
  );
};

export default ClientPortalLogin;
